<app-section-layout>
    <ng-container leftSidebar>
      <app-leftmenu
      ></app-leftmenu>    
    </ng-container>
      <ng-container mainContent>           
        <router-outlet></router-outlet>
       </ng-container>
  </app-section-layout>
